// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__37hEc","NavItem":"Footer_NavItem__2SsJN","FooterMenu":"Footer_FooterMenu__3GP8d","LinksWrapper":"Footer_LinksWrapper__2LAW5","Link":"Footer_Link__3soy8"};